// 상단 가로 메뉴바 (2026-09-17 KST 추가)
//
// 레퍼런스(flexg)는 어두운 가로 바에 대분류를 늘어놓고 왼쪽 사이드바를 따로 둔다.
// 그 구성을 따라간다. 사이드바를 대체하지 않고 위에 얹는다.
//
// 항목은 사이드바와 같은 메뉴 구조에서 가져온다. 목록을 따로 적어 두면 메뉴가 추가될 때마다
// 두 곳을 고쳐야 하고, 무엇보다 권한에 따른 필터링이 갈린다. 이렇게 두면 사이드바에 보이는
// 대분류가 곧 상단바 항목이 된다.
//
// 색과 치수는 flexg 의 .headpartialwrap / .gnb li a 규칙 실측값이다.
import { glassPaneStyle, topBarColors } from "@dashboard/theme/flexgPalette";
import { Box, Text } from "@saleor/macaw-ui-next";
import { Link } from "react-router-dom";

import { useIsMenuActive } from "../../Sidebar/menu/hooks/useIsMenuActive";
import { useMenuStructureContext } from "../../Sidebar/menu/MenuStructureContext";
import { type SidebarMenuItem } from "../../Sidebar/menu/types";
import { topMenuBarHeight } from "../consts";

const TopMenuBarItem = ({ menuItem }: { menuItem: SidebarMenuItem }) => {
  const active = useIsMenuActive(menuItem);

  return (
    <Link to={menuItem.url ?? ""} style={{ textDecoration: "none" }}>
      <Box
        display="flex"
        alignItems="center"
        whiteSpace="nowrap"
        __height={topMenuBarHeight}
        __padding="0 20px"
        // 활성 표시가 생겼다 없어지며 글자가 위아래로 흔들리지 않도록
        // 비활성일 때도 같은 두께의 투명 테두리를 깔아 둔다.
        __borderBottomStyle="solid"
        __borderBottomWidth="4px"
        __borderColor={active ? topBarColors.activeBorder : "transparent"}
        __color={active ? topBarColors.itemActive : topBarColors.item}
        data-test-id={`top-menu-item-${menuItem.id}`}
      >
        <Text size={3} fontWeight="medium" __color="inherit">
          {menuItem.label}
        </Text>
      </Box>
    </Link>
  );
};

export const TopMenuBar = () => {
  const menuItems = useMenuStructureContext();

  // 라벨이 문자열인 항목만 싣는다. 문자열이 아닌 항목은 현재 '검색' 하나뿐인데,
  // 그 라벨 안에 SearchShortcut 이 들어 있다. 이걸 여기서 또 그리면 전역 '/' 키
  // 핸들러가 두 번 등록된다. 검색은 사이드바와 단축키로 이미 닿을 수 있다.
  const sections = menuItems.filter(
    item => item.type !== "divider" && !!item.url && typeof item.label === "string",
  );

  return (
    <Box
      as="nav"
      display="flex"
      alignItems="center"
      overflowX="auto"
      className="hide-scrollbar"
      // 상단 고정은 AppLayout 이 격자 배치로 처리한다. 여기서 sticky 를 걸면 이 바의
      // 격자 영역이 첫 행(50px)으로 잘려 오히려 안 붙는다.
      __height={topMenuBarHeight}
      // 사이드바와 같은 유리판. 흐릴 바탕은 AppLayout 이 이 바 뒤에 깔아 둔다.
      // (2026-09-21 KST 수정)
      style={glassPaneStyle}
      data-test-id="top-menu-bar"
    >
      {sections.map(item => (
        <TopMenuBarItem key={item.id} menuItem={item} />
      ))}
    </Box>
  );
};
